// Preferred opacity for features that are "blurred" (i.e. another feature is "focused")
export const blurOpacity = 0.25;
